export const DashboardQuicklinks = {
  en: {
    title: 'Quicklinks',
    link_0: 'Find a Provider',
    link_1: 'Schedule appointment',
    link_2: 'Virtual Visit',
    link_3: 'Check Symptoms',
    link_4: 'Test results',
    link_5: 'Current Medications',
    link_6: 'Immunization records',
    link_7: 'Visit summaries'
  },
  es: {
    title: 'Enlaces rápidos',
    link_0: 'Buscar un proveedor',
    link_1: 'Programar una cita',
    link_2: 'Consulta Virtual',
    link_3: 'Verifique los síntomas',
    link_4: 'Resultados de pruebas',
    link_5: 'Medicamentos actuales',
    link_6: 'Registros de vacunación',
    link_7: 'Resúmenes de visitas'
  }
};

export const MyCareTeamHeader = {
  en: {
    title: 'My Care team',
    search_placeholder: 'Find care team'
  },
  es: {
    title: 'Mi equipo de atención',
    search_placeholder: 'Buscar equipo de atención'
  }
};

export const ProviderList = {
  en: {
    btnText: 'View all my care team'
  },
  es: {
    btnText: 'Ver todo mi equipo de atención'
  }
};

export const DashboardAppointments = {
  en: {
    title: 'Upcoming appointments',
    btnText: 'View all',
    btnText2: 'Schedule appointment'
  },
  es: {
    title: 'Próximas citas',
    btnText: 'Ver todo',
    btnText2: 'Programar una cita'
  }
};

export const DashboardMessages = {
  en: {
    title: 'Messages',
    btnText: 'New Message',
    btnText2: 'View inbox'
  },
  es: {
    title: 'Mensajes',
    btnText: 'Nuevo mensaje',
    btnText2: 'Ver la bandeja de entrada'
  }
};

export const DashboardUpdates = {
  en: {
    title: 'Updates',
    btnText: 'View all'
  },
  es: {
    title: 'Actualizaciones',
    btnText: 'Ver todo'
  }
};
